import {
  formatStockNumber,
  normalizeStockPrefix,
  STOCK_NUMBER_COUNTER_COLLECTION,
  stockNumberCounterDocId,
} from '@otw/models/inventory'
import { db } from 'config/firebase'
import { doc, runTransaction } from 'firebase/firestore'

/**
 * Reserves the next stock number for a prefix from `counters/stock_<PREFIX>`.
 * A missing counter starts at 1, which is only safe after existing prefixes
 * have been seeded.
 */
export const allocateStockNumber = async (prefix: string): Promise<string> => {
  const normalized = normalizeStockPrefix(prefix)
  const counterRef = doc(db, STOCK_NUMBER_COUNTER_COLLECTION, stockNumberCounterDocId(normalized))

  return runTransaction(db, async transaction => {
    const counterSnap = await transaction.get(counterRef)
    const nextSequence = counterSnap.exists()
      ? Math.max(1, Number(counterSnap.data()?.next) || 1)
      : 1

    const stockNumber = formatStockNumber(normalized, nextSequence)
    transaction.set(counterRef, { prefix: normalized, next: nextSequence + 1 }, { merge: true })
    return stockNumber
  })
}

export const stockAllocationErrorMessage = (error: unknown): string => {
  if (error instanceof Error && error.message.startsWith('Invalid stock number prefix')) {
    return 'Your account needs a first and last name before a stock number can be assigned.'
  }
  return 'Could not assign a stock number. Try again.'
}
